var map = {
	"./About.vue": [
		"f820",
		"chunk-347b97f8"
	],
	"./Home.vue": [
		"bb51",
		"chunk-3bdc9b7a"
	],
	"./affiliate-program.vue": [
		"0ca5",
		"chunk-406f8a81"
	],
	"./agreement-container.vue": [
		"51d4",
		"chunk-2d0c7ce2"
	],
	"./agreements/cookie-policy.vue": [
		"d1ec",
		"chunk-2d21daa1"
	],
	"./agreements/discount-terms-and-conditions.vue": [
		"008c",
		"chunk-2d0a2e21"
	],
	"./agreements/fair-usage-policy.vue": [
		"2891",
		"chunk-2d0b34d4"
	],
	"./agreements/free-domain-terms.vue": [
		"2479",
		"chunk-2d0b259a"
	],
	"./agreements/index.vue": [
		"04db",
		"chunk-49af3444"
	],
	"./agreements/january-sale-terms.vue": [
		"d67a",
		"chunk-2d21e7d2"
	],
	"./agreements/privacy-policy.vue": [
		"39d5",
		"chunk-2d0bb22d"
	],
	"./agreements/security-and-data-processing.vue": [
		"adb6",
		"chunk-2d213c6d"
	],
	"./agreements/terms-and-conditions.vue": [
		"40e5",
		"chunk-2d0c04e2"
	],
	"./agreements/third-party-processors.vue": [
		"d15e",
		"chunk-2d21d4d3"
	],
	"./cdn.vue": [
		"a9ca",
		"chunk-654b6670"
	],
	"./contact-original.vue": [
		"db0f",
		"chunk-6915d26e"
	],
	"./contact.vue": [
		"4fe8",
		"chunk-74541be3"
	],
	"./domain-names.vue": [
		"25c0",
		"chunk-aae30ff8"
	],
	"./email-hosting.vue": [
		"e883",
		"chunk-659d01b8"
	],
	"./green-credentials.vue": [
		"3049",
		"chunk-7f0772d4"
	],
	"./home-original.vue": [
		"889e",
		"chunk-4c111758"
	],
	"./managed-wordpress.vue": [
		"552b",
		"chunk-1f61fd06"
	],
	"./offers.vue": [
		"8cd2",
		"chunk-2d0e95af"
	],
	"./reseller-hosting.vue": [
		"5fa4",
		"chunk-78522350"
	],
	"./status.vue": [
		"d78e",
		"chunk-35cd0aea"
	],
	"./vps-original.vue": [
		"b621",
		"chunk-1d39e93c"
	],
	"./vps-sale.vue": [
		"f840",
		"chunk-5702fb75"
	],
	"./vps.vue": [
		"82b0",
		"chunk-f69dc62e"
	],
	"./web-hosting.vue": [
		"231f",
		"chunk-4bbf1e21"
	],
	"./website-builder.vue": [
		"4555",
		"chunk-6a5addc8"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "1a5d";
module.exports = webpackAsyncContext;